<template>
  <SidebarLayout>
    <ul id="promotor-menu" class="list-menu">
      <router-link to="/promoter" tag="li">
        <router-link to="/promoter">
          <img class="icon" :src="promotorIcon" />
          <span class="text-menu">Promotor</span>
        </router-link>
      </router-link>

      <!-- <li>
        <router-link to="/inspirator/grid">
          <img class="icon" :src="inspiratorGroupIcon" />
          <span class="text-menu">Collection View</span>
        </router-link>
      </li> -->
    </ul>
  </SidebarLayout>
</template>

<script>
import SidebarLayout from "./SidebarLayout";
import promotorIcon from "@/assets/images/ew-icon_promoter.png";
// import inspiratorGroupIcon from "@/assets/images/icons/ew-icon_inspirator_group.svg";

export default {
  components: {
    SidebarLayout,
  },
  data() {
    return {
      promotorIcon,
      // inspiratorGroupIcon,
    };
  },
};
</script>

<style lang="scss">
#promotor-menu {
  li {
    &:hover,
    &.active,
    &.router-link-exact-active {
      background-color: #93014A;
    }
  }
}
</style>